'use client';
// NOTE: If you're here to improve performance, ignore this file. 0 performance impact.
import { createContext, use } from 'react';

import { getDictionary, Locale } from '@/lib/i18n/dictionaries';

export type TranslationsTypes = Awaited<ReturnType<typeof getDictionary>>;

const TranslationContext = createContext<
  | {
      lang: Locale;
      texts: TranslationsTypes;
    }
  | undefined
>(undefined);

export function useTranslation() {
  const context = use(TranslationContext);

  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
}

export function useLocale() {
  return useTranslation().lang;
}

export function TranslationProvider({
  children,
  lang,
  messages,
}: {
  children: React.ReactNode;
  lang: Locale;
  // TODO add types
  messages: Awaited<ReturnType<typeof getDictionary>>;
}) {
  return (
    <TranslationContext.Provider value={{ lang, texts: messages }}>
      {children}
    </TranslationContext.Provider>
  );
}
